module.exports = __webpack_public_path__ + "static/media/method-scene-banner.83833391.png";